__turbopack_context__.v({
  "button-intro": "Nb0XEG_button-intro",
  "button-wrapper": "Nb0XEG_button-wrapper",
  "icon": "Nb0XEG_icon",
  "navigation": "Nb0XEG_navigation",
  "navigation-toggle": "Nb0XEG_navigation-toggle",
  "open": "Nb0XEG_open",
  "overlay": "Nb0XEG_overlay",
  "placeholder": "Nb0XEG_placeholder",
  "root": "Nb0XEG_root",
  "section": "Nb0XEG_section",
  "title": "Nb0XEG_title",
  "toggled": "Nb0XEG_toggled",
  "visible": "Nb0XEG_visible",
});
